import React, {Component} from "react";
import "./Textarea.css";

import TextareaAutosize from "react-autosize-textarea";

export default class Textarea extends Component
{
	componentDidMount()
	{

	}

	render()
	{
		return (
			<TextareaAutosize
				onChange={this.props.onChange}
				value={this.props.value}
				className={this.props.className + " textarea"}
				spellCheck={this.props.spellCheck}
			/>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Input/Textarea/Textarea.js